var map = {
	"./404.svg": "8e71",
	"./Union.svg": "1989",
	"./accordeon-arrow.svg": "b380",
	"./account.png": "3b2e",
	"./advantages-bitcoin.png": "8d0c",
	"./advantages-orders.png": "41ba",
	"./advantages-security.png": "9a64",
	"./advantages-user.png": "e29a",
	"./alert.png": "95e1",
	"./arrow-link.png": "7dd7",
	"./artist-img.jpg": "9bd1",
	"./artist/artist-img-1.jpg": "6357",
	"./artist/artist-img-2.jpg": "3edd",
	"./artist/artist-img-3.jpg": "3ad7",
	"./artist/artist-img-4.jpg": "f432",
	"./artist/artist-img-5.jpg": "3d07",
	"./artist/artist-img-6.jpg": "4305",
	"./artist/artist-img-7.jpg": "56b4",
	"./artist/artist-img-8.jpg": "6c65",
	"./artist/artist-img-9.jpg": "623f",
	"./auction.png": "94d8",
	"./auth-facebook.svg": "e040",
	"./capabilities-interface.png": "d327",
	"./capabilities-marg.png": "eeff",
	"./capabilities-orders.png": "d52b",
	"./capabilities-security.png": "b895",
	"./capabilities-trading.png": "3d67",
	"./capabilities-types.png": "a5f8",
	"./cd-close-filter.svg": "5a0a",
	"./cd-icon-filter.svg": "1ebc",
	"./cd-icon-filter2.svg": "d9aa",
	"./cent.png": "91f1",
	"./circle-reg.svg": "5d74",
	"./close.svg": "1d1b",
	"./coming-soon.svg": "2941",
	"./comments.png": "7dbc",
	"./company-avatar__default.png": "48a6",
	"./concordium-logo-black.png": "3b90",
	"./concordium-logo-white.png": "8166",
	"./cta-bg.png": "37cf",
	"./default-account-image.png": "493d",
	"./default-popup-image.png": "5b3d",
	"./default-profile-download.png": "6ebe",
	"./default-song-image.jpg": "0c52",
	"./default-user-image.png": "47dd",
	"./djooky-music-awards.svg": "bdb1",
	"./djooky-records.svg": "8a83",
	"./djooky-summit.svg": "10a6",
	"./djooky-talks.svg": "f9b1",
	"./djooky_logo.svg": "da57",
	"./ecosystem_djookyx.svg": "ba9f",
	"./error404.svg": "f1a6",
	"./exchange.png": "a741",
	"./exchange1.png": "4ba2",
	"./exchange2.png": "cc47",
	"./face.png": "257e",
	"./facebook-reg.svg": "ea4b",
	"./facebook.png": "5bf0",
	"./favicon.ico": "a9b3",
	"./fb.png": "2369",
	"./file.svg": "ea02",
	"./filter-arrows.svg": "e0cd",
	"./flags.png": "6cc6",
	"./flags@2x.png": "830c",
	"./google.svg": "ccc8",
	"./home/home-how-it-works.jpg": "a57e",
	"./home/home-news-img-1.jpg": "002a",
	"./home/home-news-img-2.jpg": "28db",
	"./home/home-news-img-3.jpg": "5560",
	"./home/home-slider-img.jpg": "053a",
	"./home/pending-img-1.jpg": "164b",
	"./home/pending-img-2.jpg": "ff00",
	"./home/pending-img-3.jpg": "e0f7",
	"./home/winners-img-1.jpg": "3de1",
	"./home/winners-img-2.jpg": "88f1",
	"./home/winners-img-3.jpg": "9902",
	"./how-it-works-big.svg": "2581",
	"./ieo/ieo-img-1.jpg": "6af8",
	"./ieo/ieo-img-2.jpg": "d564",
	"./ieo/ieo-img-3.jpg": "4f01",
	"./ieo/ieo-img-4.jpg": "5b80",
	"./image-promo1.png": "fa9b",
	"./image-promo2.png": "1376",
	"./image-promo3.png": "8f1a",
	"./inst.png": "d812",
	"./insta-soc-bg.svg": "a027",
	"./insta.png": "e007",
	"./instagramm-reg.svg": "3cc3",
	"./listing-coins.svg": "d218",
	"./locked.png": "2bd8",
	"./log.png": "f1c0",
	"./logo-icon.ico": "f7da",
	"./logo-icon.svg": "1515",
	"./logo.svg": "1ae4",
	"./logo_png.png": "8941",
	"./main-logo.svg": "6ac5",
	"./mangopay-call-error.png": "f7fb",
	"./mangopay-logo.svg": "237e",
	"./mangopay-tc-logo.85416a6c.png": "90c0",
	"./message.png": "06b9",
	"./new-default-user-image-big.png": "1fa2",
	"./new-default-user-image-small.png": "acab",
	"./news.png": "ea023",
	"./news1.png": "93be",
	"./photo-example.jpg": "943a",
	"./play.svg": "cc2e",
	"./pr-communic.svg": "cd40",
	"./print.svg": "7de2",
	"./processing-pink.svg": "564a",
	"./profile-background__default.png": "f0e3",
	"./profile-calendar.svg": "ad92",
	"./profile-default-image.png": "07b4",
	"./profile-favorite.svg": "9d6a",
	"./profile-financial-operations.svg": "a7ca",
	"./profile-location.svg": "a984",
	"./profile-mail.svg": "a6cd",
	"./profile-media.svg": "33cc",
	"./profile-my-orders.svg": "d9b4",
	"./profile-my-songs.svg": "debc",
	"./profile-notifications.svg": "9357",
	"./profile-phone.svg": "0b52",
	"./profile-pm.svg": "78df",
	"./profile-trading-history.svg": "ea78",
	"./profile-user.svg": "778e",
	"./profile-wallet.svg": "a3a4",
	"./refresh-player-active.svg": "8eba",
	"./refresh-player-black.svg": "2c2f",
	"./refresh-player.svg": "4b4e",
	"./reg-check.svg": "8662",
	"./reg-select-arrow.svg": "de6f",
	"./search.svg": "6f6b",
	"./sec.png": "c383",
	"./select-arrow-botom-black.svg": "0def",
	"./select-arrow-botom.svg": "a972",
	"./slick-slider-nav-next.svg": "f85b",
	"./slick-slider-nav-prev.svg": "44f6",
	"./slider-arrow-l.svg": "2774",
	"./slider-arrow-r.svg": "55a0",
	"./slider-location-icon.svg": "285c",
	"./song-image.jpg": "e2b6",
	"./statistics-list-icon.svg": "0cda",
	"./stop.svg": "9cd3",
	"./success-simple-pink.svg": "ce3e",
	"./success.svg": "d1ae",
	"./telegram-reg.svg": "f111",
	"./telephone.png": "bd85",
	"./tik.png": "cde9",
	"./tik_tok.png": "c35b",
	"./trading-not_enough-plug.svg": "560b",
	"./trash-2.svg": "5c45",
	"./trash.svg": "5665",
	"./twit.png": "79c5",
	"./twitter-reg.svg": "fc8e",
	"./twitter.png": "13a4",
	"./upload_a_video.jpg": "7135",
	"./user.png": "0f71",
	"./video_upload.png": "cb4e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";